import { AlertTriangle } from 'lucide-react'

interface ClarificationMarkersProps {
  markers: Array<{
    field: string
    reason: string
    suggestedQuestions?: string[]
  }>
}

export function ClarificationMarkers({ markers }: ClarificationMarkersProps) {
  if (!markers?.length) return null

  return (
    <div className="my-3 rounded-xl border border-amber-200/60 dark:border-amber-800/40 bg-amber-50/30 dark:bg-amber-950/20 overflow-hidden">
      <div className="flex items-center gap-2.5 px-4 py-3">
        <div className="flex items-center justify-center size-7 rounded-lg bg-amber-100 dark:bg-amber-900/40">
          <AlertTriangle className="size-3.5 text-amber-600 dark:text-amber-400" strokeWidth={1.5} />
        </div>
        <span className="text-sm font-medium text-foreground">Needs Clarification</span>
      </div>
      <div className="px-4 pb-4 space-y-3">
        {markers.map((marker, i) => (
          <div key={i} className="space-y-1.5">
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-foreground">{marker.field}</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {marker.reason}
            </p>
            {marker.suggestedQuestions && marker.suggestedQuestions.length > 0 && (
              <ul className="space-y-1 mt-2">
                {marker.suggestedQuestions.map((q, j) => (
                  <li
                    key={j}
                    className="text-xs text-muted-foreground/80 pl-3 border-l-2 border-amber-300/40 dark:border-amber-700/40"
                  >
                    {q}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
